export default {"src":"/_next/static/media/clp_logo.fe1f77a2.svg","height":85,"width":189,"blurWidth":0,"blurHeight":0};